var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{staticClass:"about-paragraph"},[(_vm.content.title)?_c('h3',[_vm._v(_vm._s(_vm.content.title))]):_vm._e(),_c('p',[_vm._v(" "+_vm._s(_vm.content.content)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }